export default "__VITE_ASSET__BXynDRxR__"